import { company } from "../data/content";

export default function WhatsAppButton() {
  const digits = company.mobile.replace(/[^\d]/g, ""); // e.g. "6281933281204"
  const message = encodeURIComponent(
    "Hi Bumi Logistics, I'd like to ask about your freight & logistics services."
  );
  const href = `https://wa.me/${digits}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="30" height="30" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.02 3C9.4 3 4 8.4 4 15.02c0 2.23.61 4.31 1.67 6.1L3 29l8.1-2.62a12.9 12.9 0 004.92.98h.01C22.65 27.36 28 21.96 28 15.34 28 8.72 22.65 3 16.02 3zm0 22.6a10.5 10.5 0 01-5.36-1.47l-.38-.23-4.8 1.56 1.57-4.68-.25-.4a10.55 10.55 0 01-1.6-5.36c0-5.84 4.75-10.6 10.6-10.6 5.84 0 10.6 4.76 10.6 10.6 0 5.84-4.76 10.58-10.6 10.58z"
        />
        <path
          fill="currentColor"
          d="M21.6 18.1c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.22-.65.08-.3-.15-1.28-.47-2.44-1.5-.9-.8-1.5-1.8-1.68-2.1-.18-.3-.02-.46.13-.6.13-.13.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.63-.93-2.23-.24-.58-.5-.5-.68-.5h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.13 3.25 5.16 4.55.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.18-1.43-.08-.13-.28-.2-.58-.35z"
        />
      </svg>
    </a>
  );
}
